import { FormGroup } from "@angular/forms";

export function validate(form: FormGroup): boolean {
    // debugger
    if (form.invalid) {
        Object.keys(form.controls).forEach((field) => {
            const control = form.get(field);
            // console.log('control', control);
            if (control) {
                control.markAsTouched({ onlySelf: true });
            }
        });
        return false;
    } else {
        return true;
    }
}